import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import { TEAM, teamPhoto, teamSlug } from "@/data/team";

const TeamStrip = () => (
  <section data-testid="home-team-section" className="relative bg-navy border-y border-white/5 grain overflow-hidden">
    <div className="absolute -top-24 left-1/3 w-96 h-64 bg-brand/15 blur-[120px] rounded-full" aria-hidden="true" />
    <div className="relative max-w-8xl mx-auto px-6 lg:px-12 py-20 lg:py-28">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-14 items-center">
        <div className="lg:col-span-4">
          <Reveal>
            <p className="text-xs md:text-sm uppercase tracking-[0.25em] text-electric font-medium">Meet The Team</p>
            <h2 className="mt-4 font-display font-extrabold tracking-tighter text-3xl md:text-4xl text-mist leading-tight">
              Small team. <span className="text-electric">Hands-on everything.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-5 text-slatec leading-relaxed text-sm md:text-base">
              Eight specialists across strategy, content, ads and 360° — directly involved in every project we take on.
            </p>
            <Link
              to="/about#team"
              data-testid="home-team-cta"
              className="mt-7 inline-flex items-center gap-2 text-electric font-semibold hover:gap-3 transition-[gap] duration-300"
            >
              Meet the full team <ArrowUpRight size={18} />
            </Link>
            <p className="mt-4">
              <Link
                to="/careers"
                data-testid="home-team-careers-link"
                className="text-sm text-mist/60 hover:text-electric underline underline-offset-4 decoration-white/20 hover:decoration-electric/60 transition-colors duration-200"
              >
                Want to join us? See open roles
              </Link>
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-8">
          <div className="flex flex-wrap gap-x-5 gap-y-8 lg:justify-end">
            {TEAM.map((m, i) => (
              <Reveal key={m.name} delay={0.05 * i}>
                <div data-testid={`home-team-member-${teamSlug(m)}`} className="group w-24 md:w-28 text-center">
                  <div className="relative w-20 h-20 md:w-24 md:h-24 mx-auto rounded-full overflow-hidden border border-white/15 group-hover:border-electric/50 transition-colors duration-300">
                    <img
                      src={teamPhoto(m)}
                      alt={`${m.name} — ${m.role}, Click World Online`}
                      loading="lazy"
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                  </div>
                  <p className="mt-3 font-display font-bold text-mist text-sm leading-tight">{m.name}</p>
                  <p className="mt-1 text-[11px] uppercase tracking-[0.12em] text-mist/45 leading-snug">{m.role}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default TeamStrip;
